"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireWildcard(require("react"));
var _reactflow = _interopRequireWildcard(require("reactflow"));
require("reactflow/dist/style.css");
var _locale = require("../locale");
var _overviews = require("../previews/overviews");
var _pages = _interopRequireDefault(require("../previews/pages"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Zoom = /*#__PURE__*/(0, _react.memo)(function () {
  var reactFlow = (0, _reactflow.useReactFlow)();
  var _useViewport = (0, _reactflow.useViewport)(),
    zoom = _useViewport.zoom;
  var locale = (0, _locale.useLocale)();
  var handleZoomTo = function handleZoomTo() {
    if (zoom === 1) {
      reactFlow.zoomTo(0.5);
    } else {
      reactFlow.zoomTo(1);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
    title: zoom === 1 ? "".concat(locale.demo.zoomTo, " 2:1") : "".concat(locale.demo.zoomTo, " 1:1")
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    onClick: handleZoomTo,
    style: {
      width: 64
    }
  }, Math.round(zoom * 100), "%"));
});
var Controls = function Controls() {
  var _useReactFlow = (0, _reactflow.useReactFlow)(),
    zoomIn = _useReactFlow.zoomIn,
    zoomOut = _useReactFlow.zoomOut,
    fitView = _useReactFlow.fitView;
  var locale = (0, _locale.useLocale)();
  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    style: {
      zIndex: 100,
      position: 'absolute',
      bottom: 10,
      right: 10
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.MinusOutlined, null),
    onClick: function onClick() {
      return zoomOut();
    }
  }), /*#__PURE__*/_react.default.createElement(Zoom, null), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null),
    onClick: function onClick() {
      return zoomIn();
    }
  }), /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
    title: locale.demo.fitView
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.ExpandOutlined, null),
    onClick: function onClick() {
      return fitView();
    }
  })));
};
var Artboard = function Artboard(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_react.default.createElement("div", null, data);
};
var nodeTypes = {
  artboard: Artboard
};
var Demo = function Demo(_ref2) {
  var mode = _ref2.mode,
    theme = _ref2.theme;
  var _antdTheme$useToken = _antd.theme.useToken(),
    token = _antdTheme$useToken.token;
  return /*#__PURE__*/_react.default.createElement(_antd.ConfigProvider, {
    theme: _objectSpread(_objectSpread({}, theme.config), {}, {
      inherit: false
    })
  }, /*#__PURE__*/_react.default.createElement("div", null, mode === 'overview' ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    size: 24,
    align: "start"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 24,
    style: {
      width: 960
    }
  }, /*#__PURE__*/_react.default.createElement(_overviews.Primary, {
    id: "primary-demo"
  }), /*#__PURE__*/_react.default.createElement(_overviews.Success, {
    id: "success-demo"
  })), /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 24,
    style: {
      width: 960
    }
  }, /*#__PURE__*/_react.default.createElement(_overviews.Error, {
    id: "error-demo"
  }), /*#__PURE__*/_react.default.createElement(_overviews.Warning, {
    id: "warning-demo"
  })))) : /*#__PURE__*/_react.default.createElement(_pages.default, {
    style: {
      width: 1440,
      height: 'calc(100% - 20px)',
      boxShadow: token.boxShadowTertiary,
      borderRadius: token.marginXS,
      overflow: 'hidden',
      border: "1px solid ".concat(token.colorBorder)
    }
  })));
};
var GlobalTokenDemos = function GlobalTokenDemos(props) {
  var theme = props.theme;
  var _React$useState = _react.default.useState('page'),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    mode = _React$useState2[0],
    setMode = _React$useState2[1];
  var locale = (0, _locale.useLocale)();
  var _antdTheme$useToken2 = _antd.theme.useToken(),
    token = _antdTheme$useToken2.token;
  var _useReactFlow2 = (0, _reactflow.useReactFlow)(),
    fitView = _useReactFlow2.fitView;
  var nodesInitialized = (0, _reactflow.useNodesInitialized)();
  (0, _react.useEffect)(function () {
    if (nodesInitialized) {
      fitView();
    }
  }, [nodesInitialized]);
  return /*#__PURE__*/_react.default.createElement(_reactflow.default, {
    minZoom: 0.25,
    maxZoom: 4,
    nodes: [{
      id: "artboard-".concat(mode),
      type: 'artboard',
      data: /*#__PURE__*/_react.default.createElement(Demo, {
        mode: mode,
        theme: theme
      }),
      draggable: false,
      connectable: false,
      position: {
        x: 0,
        y: 0
      }
    }],
    nodeTypes: nodeTypes,
    onlyRenderVisibleElements: true,
    panOnScroll: true,
    panOnDrag: false,
    zoomOnScroll: false,
    fitView: true,
    proOptions: {
      hideAttribution: true
    }
  }, /*#__PURE__*/_react.default.createElement(_reactflow.Panel, {
    position: "top-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Segmented, {
    options: [{
      value: 'page',
      label: locale.demo.page
    }, {
      value: 'overview',
      label: locale.demo.overview
    }],
    value: mode,
    onChange: setMode,
    style: {
      boxShadow: token.boxShadowTertiary
    }
  })), /*#__PURE__*/_react.default.createElement(Controls, null), /*#__PURE__*/_react.default.createElement(_reactflow.Background, {
    color: token.colorTextSecondary,
    gap: 16,
    style: {
      zIndex: -1,
      background: token.colorBgLayout
    }
  }));
};
var _default = exports.default = function _default(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread({
      position: 'relative'
    }, props.style)
  }, /*#__PURE__*/_react.default.createElement(_reactflow.ReactFlowProvider, null, /*#__PURE__*/_react.default.createElement(GlobalTokenDemos, props)));
};